import React from "react";

const ActivitiesSectionEN = () => {
  return (
    <section id="activities" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-[#1C3A27] mb-6">
            Activities nearby
          </h2>
          <p className="text-xl text-[#1C3A27]/70 max-w-3xl mx-auto">
            Discover the treasures of Norman Switzerland and beyond
          </p>
        </div>
        {/* Activities content coming soon */}
      </div>
    </section>
  );
};

export default ActivitiesSectionEN;